import { render, staticRenderFns } from "./modal-details-sales.vue?vue&type=template&id=23c76932&scoped=true"
import script from "./modal-details-sales.vue?vue&type=script&lang=js"
export * from "./modal-details-sales.vue?vue&type=script&lang=js"
import style0 from "./modal-details-sales.vue?vue&type=style&index=0&id=23c76932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c76932",
  null
  
)

export default component.exports